<template>
    <div class="container">
        <SiteHeader></SiteHeader>

        <h2 class="text-center">Reset password</h2>

        <form @submit.prevent="formSubmit">
            <h4>Enter your new password:</h4>

            <div v-if="errorForm" class="form-error">
                <p>{{ errorForm }}</p>
                <p>
                    <span class="link" @click="openForgotPasswordModal">Send a new link</span>
                </p>
            </div>

            <div class="form-field">
                <label class="form-field-label">Password</label>
                <input type="password" name="password" v-model.trim="password"/>
                <small v-if="errorPassword" class="error-text">Password length must be at least 6 characters</small>
            </div>

            <div class="form-field">
                <label class="form-field-label">Repeat password</label>
                <input type="password" name="password2" v-model.trim="passwordRepeat"/>
                <small v-if="errorPasswordRepeat" class="error-text">Passwords do not match</small>
            </div>

            <div class="text-center">
                <br>
                <Button type="submit" :loading="sendStatus">Restore password</Button>
            </div>
        </form>

        <ForgotPasswordModal v-if="displayForgotPasswordModal"
                             @closeModal="closeForgotPasswordModal"
        ></ForgotPasswordModal>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import SiteHeader from "../components/SiteHeader";
    import Button from "../components/Button";
    import ForgotPasswordModal from "./userCabinet/ForgotPasswordModal";

    export default {
        name: "ResetPassword",

        components: {
            ForgotPasswordModal,
            Button,
            SiteHeader,
        },

        data() {
            return {
                sendStatus: false,

                hash: null,
                password: '',
                passwordRepeat: '',

                errorForm: false,
                errorPassword: false,
                errorPasswordRepeat: false,

                displayForgotPasswordModal: false,
            }
        },

        computed: {
            ...mapState('authentication', [
                'authenticationStatus',
            ]),

        },

        methods: {
            ...mapActions('authentication', [
                'resetPassword',
            ]),

            resetErrors() {
                this.errorForm = false;
                this.errorPassword = false;
                this.errorPasswordRepeat = false;
            },

            validation() {
                let isError = false;

                if (this.password.length < 6) {
                    this.errorPassword = true;
                    isError = true;
                }

                if (this.password.trim() !== this.passwordRepeat.trim()) {
                    this.errorPasswordRepeat = true;
                    isError = true;
                }

                return isError;
            },

            formSubmit() {
                this.resetErrors();

                let isError = this.validation();

                if (isError) return;

                let data = {
                    password: this.password,
                    hash: this.hash,
                };

                this.sendStatus = true;

                this.resetPassword(data)
                    .then(() => {
                        // reset password was success
                        // now the user is login
                        // redirect the user to the home page
                        this.redirectUserToHomePage(true);
                    })
                    .catch(error => {
                        this.errorForm = error;
                    })
                    .finally(() => {
                        this.sendStatus = false;
                    });
            },

            redirectUserToHomePage(authenticationStatus) {
                // redirect the user to the home page after login
                if (authenticationStatus) {
                    this.$router.push({ to: '/' });
                }
            },

            openForgotPasswordModal() {
                this.displayForgotPasswordModal = true;
            },

            closeForgotPasswordModal() {
                this.displayForgotPasswordModal = false;
            },

        },

        watch: {
            authenticationStatus(value) {
                this.redirectUserToHomePage(value);
            },

        },

        beforeMount() {
            // check if the user is already login
            this.redirectUserToHomePage(this.authenticationStatus);

            // get the hash from the URL sent to the user's email address
            const query = this.$route.query;
            const hash = query['hash'];

            if (hash) {
                this.hash = hash;
            }
        },

    }
</script>

<style scoped>
    form {
        width: 400px;
        max-width: 100%;
        margin: 50px auto;
    }
</style>